export enum SecureSection {
    HowDoesItWork,
    InvestmentAllocation,
    QuestionsAndAnswers
}
